function Header() {
  return (
    <section className="hero is-small header-style has-text-centered"> 
      <div className="hero-head"> 
        <p className="title has-text-light">Trippy</p>
        <p className="subtitle has-text-light">Explore alternative places in London</p>
      </div>
    </section>
  )

}
export default Header